import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import Cards from 'components/Card';
import professionEndPoint from 'endPoints/professions';
import useDataListFactory from 'services/dataList';
import useIntersectionObserver from 'helpers/useIntersectionObserver';
import LinearProgress from 'components/LinearProgress';
import { COLUMNS_LIMIT } from 'variables/main';
import { getLanguage } from 'translation';

const useDataList = (props, options) => useDataListFactory(props, options);

const Background = styled('section')(({ theme }) => ({
  backgroundColor: theme.palette.backgroundNeutral.main
}));

const HomeProfessionsWrapper = styled('div')(({ theme }) => ({
  padding: '80px 100px 32px',
  boxSizing: 'border-box',
  ...theme.wrapper,
  [theme.breakpoints.down('lg')]: {
    padding: '50px 50px 24px'
  },
  [theme.breakpoints.down('md')]: {
    padding: '30px 30px 20px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '30px 20px 16px'
  }
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 40,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: theme.palette.textPrimary.main,
  [theme.breakpoints.down('lg')]: {
    display: 'block'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    lineHeight: '41.4px',
    marginBottom: 20
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    lineHeight: '36.4px',
    marginBottom: 25
  }
}));

const TitleDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.textPrimary.main,
  paddingLeft: 50,
  position: 'relative',
  top: 4,
  [theme.breakpoints.down('lg')]: {
    paddingLeft: 0
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    lineHeight: '27px',
    marginTop: 25,
    position: 'static'
  }
}));

const HomeProfessions = ({ texts }) => {
  const [ref, isVisible] = useIntersectionObserver({
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  });
  const lang = getLanguage();

  const { data } = useDataList(
    {
      ...professionEndPoint,
      autoLoad: isVisible
    },
    { perPage: COLUMNS_LIMIT }
  );

  return (
    <Background ref={ref}>
      <HomeProfessionsWrapper>
        <Title variant="h2">
          {texts?.occupations_headline?.[lang]}
          <TitleDescription variant="body1">
            {texts?.occupations_subheadline?.[lang]}
          </TitleDescription>
        </Title>
        <Cards list={data} />
        {!data ? <LinearProgress /> : null}
      </HomeProfessionsWrapper>
    </Background>
  );
};

export default HomeProfessions;
